import Vue from 'vue'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import Vuex from 'vuex'


Vue.use(Vuex)

import { db } from '../main.js';

export default new Vuex.Store({
  state: {
    products: [],
    banners: [],
    brands: [],
  },
  computed:{
  },
  mutations: {
    ...vuexfireMutations,
    getData (state,opts) {
      var server_url = 'https://js.virtuamegastore.com.br/server/serverData.php';
      opts.store_id = 1;
      opts.action = 'getProducts';
      opts.url_host = window.location.host;
      opts.url_path = window.location.pathname;
      opts.url_search = window.location.search;
      var opts_url = new URLSearchParams(opts);
      fetch(server_url,{method:'post',body:opts_url})
      .then(response => response.json())
      //.then(result => {state.products = result.products;state.banners = result.banners;alert(JSON.stringify(result));this.server_data = result});
      .then(result => {
          state.products = state.products.concat(result.products);
          state.banners = result.banners;
      });
    },
    getDataFireStore(state){
      console.log('firestore get');
      state.brands =
      db.collection("brands").get().then(function(querySnapshot) {
        var result = [];
        querySnapshot.forEach(function(doc) {
            console.log(doc.data());
            result[doc.id] = doc.data();
            state.bramds[doc.id] = doc.data();
          })
      })
    },
    setDataFireStore(state,data){
      console.log('firestore set');
      return db.collection('brands').add(data);
    }
  },
  actions: {
    getData (context,opts) {
      context.commit('getData',opts);
    },
    setDataFireStore (context,data) {
      context.commit('setDataFireStore',data);
    },
    getDataFireStore (context) {
      context.commit('getDataFireStore');
    },
    bindBrands: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef('brands', db.collection('brands'))
    }),
    unbindBrands: firestoreAction(({ unbindFirestoreRef }) => {
      unbindFirestoreRef('brands')
    }),
  },
  created: function () {
  },
  modules: {
  }
})
